import { Attachment } from "airtable"
import Image from "next/image"
import Zoom from "react-medium-image-zoom"
import tw, { css, styled } from "twin.macro"

interface MediaProps {
  id: string
  title: string
  image: any
  caption: string
  zoom?: boolean
  showCaption?: boolean
  width?: number
  height?: number
}

const StyledFrame = styled("div")(() => [
  tw`
    h-full w-full
    flex justify-center relative
    max-h-[850px]
  `,
  css`
    img {
      object-fit: scale-down;
    }
  `,
])

export const Media = (props: MediaProps) => {
  const { id, title, caption, image, zoom, showCaption, width, height } = props
  const captionElement = !!caption && showCaption && <p tw="text-sm">{caption}</p>

  const thisImage = image[0]
  const thisImageHeight = !!height ? height : thisImage.height
  const thisImageWidth = !!width ? width : thisImage.width
  const thisImageThumb = thisImage.thumbnails.small.url

  const altText = caption
    ? `${title} — ${caption}} – The Richard Pousette-Dart Foundation`
    : `The Richard Pousette-Dart Foundation`

  if (zoom) {
    return (
      <Zoom
        zoomImg={{
          alt: `${title} — ${caption}`,
          src: thisImage.url,
          srcSet: thisImage.url,
        }}
      >
        <StyledFrame>
          <Image
            key={id}
            src={thisImage.url}
            alt={altText}
            width={thisImageWidth}
            height={thisImageHeight}
            placeholder="blur"
            blurDataURL={thisImageThumb}
          />
          {captionElement}
        </StyledFrame>
      </Zoom>
    )
  }
  return (
    <div>
      <Image key={id} src={thisImage.url} alt={altText} width={thisImageWidth} height={thisImageHeight} />
      {captionElement}
    </div>
  )
}
export default Media

interface MediaAdditionalProps {
  id: string
  detail_images: Attachment[]
  url: string
  zoom?: boolean
  height: number
  width: number
}

export const MediaAdditional = (props: MediaAdditionalProps) => {
  const { id, url, width, height } = props

  const thisImageHeight = width
  const thisImageWidth = height

  return (
    <>
      <Zoom
        zoomImg={{
          alt: `thing`,
          src: url,
          srcSet: url,
        }}
      >
        <Image
          key={id}
          src={url}
          alt={`The Richard Pousette-Dart Foundation`}
          width={thisImageWidth}
          height={thisImageHeight}
        />
      </Zoom>
    </>
  )
}
